import { Layout, Tabs } from "antd";
import { storage } from "lib";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";



import { Content, Footer, Header } from "antd/es/layout/layout";
import MyTabsMenu from "components/elements/MyTabs/MyTabsMenu";
import { MASTER_DATA_TYPE } from "../schemas/masterDataSchema";
import styles from "../styles/MasterDataMenu.module.css";
import { useSelector } from "react-redux";
// function getItem(i18n_key, label, key, icon, children, type) {
//   return {
//     i18n_key,
//     key,
//     icon,
//     children,
//     label,
//     type,
//   };
// }

// const MASTER_SETTING_MENU = [
//   getItem(
//     "bank",
//     "Bank",
//     MASTER_DATA_TYPE.BANK,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "career",
//     "Career",
//     MASTER_DATA_TYPE.CAREER,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "reason_of_leaving",
//     "Reason for Leaving",
//     MASTER_DATA_TYPE.REASON_FOR_LEAVING,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "attachment_type",
//     "Attachment Type",
//     MASTER_DATA_TYPE.ATTACHMENT_TYPE,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "employee_type",
//     "Employee Type",
//     MASTER_DATA_TYPE.EMPLOYEE_TYPE,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "company_regulation",
//     "Company Regulation",
//     MASTER_DATA_TYPE.COMPANY_REGULATION,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "course_category",
//     "Course Category",
//     MASTER_DATA_TYPE.COURSE_CATEGORY,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "skill_type",
//     "Skill Type",
//     MASTER_DATA_TYPE.SKILL_TYPE,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "skill_set",
//     "Skill Set",
//     MASTER_DATA_TYPE.SKILL_SET,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
//   getItem(
//     "reason_of_separation",
//     "Reason for Separation",
//     MASTER_DATA_TYPE.REASON_FOR_SEPARATION,
//     <CopyOutlined style={{ color: "gray" }} />
//   ),
// ];

const MasterMenu = ({ className = "", menuList = [], onChange = () => { }, children }) => {
  const [selectedKeys, setSelectedKeys] = useState([MASTER_DATA_TYPE.BANK]);
  const { t } = useTranslation();


  const onMenuClick = (e) => {
    const key = e;
    setSelectedKeys([key]);
    onChange(key);
    storage.sessionStorage.setItem("config.menu", key);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const key = storage.sessionStorage.getItem("config.menu");
    if (key) {
      setSelectedKeys([key]);
    } else {
      setSelectedKeys([MASTER_DATA_TYPE.BANK]);
    }
  }, []);

  return (
    <Layout
      style={{
        backgroundColor: 'transparent'
      }}
      hasSider={false}
    >
      <Header style={{
        padding: 0,
        backgroundColor: 'transparent'
      }}>
        <Tabs items={menuList} onChange={onMenuClick} ></Tabs>
      </Header>
      <Content
        className={styles.content}
        style={{
          width: "100%",
          margin: '8px 8px',
          padding: 10,
          borderRadius: 0,
        }}
      >
        <div style={{
          minHeight: "30vh",
          minWidth: "30vh",
          width: "100%",
        }}>
          {children}</div>
      </Content>
      {/* <Footer></Footer> */}
    </Layout>
  );
};

export default MasterMenu;
